/**
 * The stored order, with any column shipped since it was saved inserted where the
 * catalogue puts it rather than at the end — far right of the grid is past where the
 * columns stop rendering, so a new metric would read as missing until someone went
 * looking for it. Nothing to migrate: an unsaved column simply finds its own place.
 */
export function mergeColumnOrder(stored: string[], catalogue: string[]): string[] {
  const known = new Set(catalogue);
  const ranked = stored.filter((f) => known.has(f));
  const rankedSet = new Set(ranked);

  // Each new field remembers the last ranked field before it in catalogue order.
  const after = new Map<string, string[]>();
  const leading: string[] = [];
  let anchor: string | null = null;
  for (const f of catalogue) {
    if (rankedSet.has(f)) { anchor = f; continue; }
    if (anchor === null) leading.push(f);
    else after.set(anchor, [...(after.get(anchor) || []), f]);
  }

  const out = [...leading];
  for (const f of ranked) out.push(f, ...(after.get(f) || []));
  return out;
}
